/*
  import { surveySectionList } from '@/services/Surveys/SurveySection/store'
*/

import Vue from 'vue'
import Vuex from 'vuex'
import kms from '@/services/kms'
import { notifyProblem, notifyError, notifyMessage } from '@/services/notify'
import _get from 'lodash/get'
const isDebug = true

/* eslint-disable no-empty-pattern */
const actions = {
  /*
    const { list } = await surveySectionList.dispatch ('getSurveySectionList', {
      hoaId
    });
  */
  async getSurveySectionList({}, { surveyHeaderID, includeAnswerResults }) {
    console.log('in getSurveySectionList...')
    try {
      const result = await kms.get('/Surveys/SurveySection/List', {
        params: {
          surveyHeaderID,
          includeAnswerResults
        }
      })

      if (isDebug == true) console.debug('getSurveySectionList log=' + JSON.stringify(result))

      return {
        list: result.results
      }
    } catch (exception) {
      notifyProblem(`The survey section list could not be retrieved.`)
      console.error(exception)
    }

    return {
      list: []
    }
  },

  //Survey Section by Id
  async getSurveySectionById({}, { surveySectionID }) {
    try {
      console.debug('in getSurveySecctionById...' + surveySectionID)
      const section = await kms.get(`/Surveys/SurveySection/${surveySectionID}`)

      if (isDebug == true) console.debug('getSurveySectionById=' + JSON.stringify(section))

      return {
        result: section
      }
    } catch (exception) {
      notifyProblem(`There was a problem retrieving the survey section.`)
      console.error(exception)
    }

    return {
      survey: {}
    }
  },

  async deleteSurveySection({ dispatch }, { surveySectionID, done }) {
    try {
      const path = `/Surveys/SurveySection/${surveySectionID}?forceDelete=false`

      const results = await kms.delete(path)

      if (this.isDebug == true) console.debug('results=' + JSON.stringify(results))

      if (dispatch && dispatch != undefined) console.debug(dispatch)

      const wasDeleted = _get(results, 'deleted', false)

      if (wasDeleted === true) {
        notifyMessage(`Successfully deleted the survey section.`)
        done()
      } else {
        notifyError('There was a problem deleting the survey section.')
      }
    } catch (exception) {
      notifyProblem(`There was a problem deleting this survey section.`)
      console.error(exception)
    }
  }
}
/* eslint-enable no-empty-pattern */

Vue.use(Vuex)
export const surveySectionList = new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions
})
